import React, { Component } from 'react';
import AdminRoute from '../AdminRoute';
import './styles.scss';
import { Dialog, DialogCloseButton } from '../Dialog';
import ConfirmDialog from '../ConfirmDialog';
import Modal from '../Modal';
import GameForm from '../GameForm';
import GamesTable from './GamesTable';
import GamesFilters from './GamesFilters';
import DeleteGameMutation from '../../mutations/DeleteGame';
import ResetGameMutation from '../../mutations/ResetGame';
import HeightDownAnimation from '../HeightDownAnimation';

class AdminGamesManager extends Component {
	constructor(props) {
		super(props);
		this.removeData = this.removeData.bind(this);
		this.onClickResetGame = this.onClickResetGame.bind(this);
		this.showLastDecision = this.showLastDecision.bind(this);
		this.toggleModalLastDecision = this.toggleModalLastDecision.bind(this);
		this.editGame = this.editGame.bind(this);
		this.toggleModalVisibility = this.toggleModalVisibility.bind(this);
		this.onClickAdd = this.onClickAdd.bind(this);
		this.resetGame = this.resetGame.bind(this);
		this.toggleDialogReset = this.toggleDialogReset.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onToggleOnlyCoordinators = this.onToggleOnlyCoordinators.bind(this);
		this.onClickSessionFilterSelectItem = this.onClickSessionFilterSelectItem.bind(
			this
		);
		this.toggleDialog = this.toggleDialog.bind(this);
		this.onClickConfirm = this.onClickConfirm.bind(this);
		this.state = {
			showDialog: false,
			showEdit: false,
			editingGame: null,
			showModalLastDecision: false,
			recordIdToRemove: null,
			recordIdToReset: null,
			showForm: false
		};
	}

	editGame(gameID) {
		const { paginatedGames } = this.props;
		const games = paginatedGames.edges;
		const game = games.find(game => game.id === gameID);
		this.setState({ editingGame: game }, () => {
			this.toggleModalVisibility(true);
		});
	}

	toggleModalVisibility(status) {
		const showEdit = status ? status : !this.state.showEdit;
		this.setState({
			showForm: false,
			showEdit
		});
	}

	onToggleOnlyCoordinators() {
		const { coordinator, setQueryState } = this.props;
		setQueryState({ gameCoordinator: !coordinator });
	}

	onClickSessionFilterSelectItem(ev) {
		const { setQueryState } = this.props;
		const gameSessionID = ev.target.getAttribute('data-value');
		setQueryState({
			gameSessionID: gameSessionID === 'all' ? null : gameSessionID
		});
	}

	getTeams() {
		const { teams } = this.props;
		return teams.map(team => ({
			label: team,
			value: team
		}));
	}

	onClickAdd(event) {
		event.preventDefault();
		const showForm = !this.state.showForm;
		this.setState({ showForm });
	}

	showLastDecision(id) {
		const { paginatedGames } = this.props;
		const games = paginatedGames.edges;
		const game = games.find(game => game.id === id);
		this.setState({ lastDecision: game.data.cashDecisions });
		this.toggleModalLastDecision();
	}

	resetSearchState() {
		const { setQueryState } = this.props;
		setQueryState({
			gamePage: 1,
			gameCoordinator: false,
			gameSessionID: undefined
		});
	}

	onClickResetGame(id) {
		this.setState({ recordIdToReset: id }, () => this.toggleDialogReset());
	}

	resetGame(resetGame) {
		resetGame({ variables: { gameID: this.state.recordIdToReset } });
		this.toggleDialogReset();
	}

	toggleDialogReset() {
		this.setState({ showDialogReset: !this.state.showDialogReset });
	}

	toggleModalLastDecision() {
		this.setState({ showModalLastDecision: !this.state.showModalLastDecision });
	}

	onClose() {
		this.setState({ showForm: false });
	}

	removeData(recordIdToRemove) {
		this.setState({ recordIdToRemove }, () => {
			this.toggleDialog();
		});
	}

	toggleDialog() {
		let showDialog = !this.state.showDialog;
		this.setState({
			showDialog
		});
	}

	onClickConfirm(deleteGame) {
		const { refetch } = this.props;
		const gameID = this.state.recordIdToRemove;
		this.setState({ recordIdToRemove: null }, () => {
			deleteGame({ variables: { gameID } }).then(() => {
				refetch();
			});
			this.toggleDialog();
		});
	}

	componentWillUpdate(nextProps) {
		const nextPageCount = nextProps.paginatedGames.paginationInfo.pageCount;
		if (nextPageCount < nextProps.page) {
			const { setQueryState } = this.props;
			setQueryState({
				gamePage: nextPageCount
			});
		}
	}

	render() {
		const {
			showForm,
			showEdit,
			showDialog,
			showDialogReset,
			showModalLastDecision,
			lastDecision,
			recordIdToRemove,
			recordIdToReset,
			editingGame
		} = this.state;
		const {
			users,
			coordinator,
			sessionID,
			sessions,
			paginatedGames,
			page,
			setQueryState,
			showCoordinator,
			showSessionsSelect,
			refetch
		} = this.props;
		const teams = this.getTeams();
		return (
			<DeleteGameMutation>
				{deleteGame => (
					<ResetGameMutation>
						{resetGame => (
							<div className="AdminGamesManager">
								{showDialog && (
									<ConfirmDialog
										id={recordIdToRemove}
										title={'Deleting game'}
										description={
											'Are you sure you want to delete this game?<br />Once deleted it cannot be recovered.'
										}
										icon={'trash'}
										show={showDialog}
										confirmClicked={() => this.onClickConfirm(deleteGame)}
										closeDialogClicked={this.toggleDialog}
									/>
								)}
								{showDialogReset && (
									<ConfirmDialog
										id={recordIdToReset}
										title={'Resetting game'}
										description={
											'Are you sure you want to reset this game?<br />Once reset it cannot be recovered.'
										}
										icon={'reset'}
										show={showDialog}
										confirmClicked={() => this.resetGame(resetGame)}
										closeDialogClicked={this.toggleDialogReset}
										acceptButton={'yes, reset'}
									/>
								)}
								{showEdit && (
									<Dialog
										className="AddSessionDialog"
										closeDialog={() => this.toggleModalVisibility(false)}
										outsideClose={false}>
										<DialogCloseButton
											closeDialog={() => this.toggleModalVisibility(false)}
										/>
										<GameForm
											users={users}
											sessions={sessions}
											teams={teams}
											closeForm={() => this.toggleModalVisibility(false)}
											edit={true}
											game={editingGame}
										/>
									</Dialog>
								)}
								{showModalLastDecision && (
									<Modal
										styles={{ padding: '30px 40px' }}
										width={800}
										height={340}
										show={showModalLastDecision}
										closeButton={true}
										closeDialogClicked={this.toggleModalLastDecision}>
										<h1>Last decision</h1>
										<div dangerouslySetInnerHTML={{ __html: lastDecision }} />
									</Modal>
								)}
								<AdminRoute
									title="Games"
									subTitle="Games"
									icon="gamesColor"
									buttonTheme="blue"
									buttonCta="Add game"
									filters={
										<GamesFilters
											onChangeCoordinator={this.onToggleOnlyCoordinators}
											coordinator={coordinator}
											onChangeSessionID={this.onClickSessionFilterSelectItem}
											sessionID={sessionID}
											sessions={sessions}
											showCoordinator={showCoordinator}
											showSessionsSelect={showSessionsSelect}
										/>
									}
									form={
										<HeightDownAnimation show={showForm} height="300px">
											<GameForm
												users={users}
												sessions={sessions}
												teams={teams}
												reset={() =>
													refetch({
														page,
														coordinator,
														sessionID
													})
												}
												closeForm={this.onClose}
											/>
										</HeightDownAnimation>
									}
									buttonClicked={this.onClickAdd}>
									<GamesTable
										paginatedGames={paginatedGames}
										page={page}
										setQueryState={setQueryState}
										showLastDecision={this.showLastDecision}
										onClickResetGame={this.onClickResetGame}
										editGame={this.editGame}
										removeData={this.removeData}
									/>
								</AdminRoute>
							</div>
						)}
					</ResetGameMutation>
				)}
			</DeleteGameMutation>
		);
	}
}

AdminGamesManager.defaultProps = {
	showCoordinator: true,
	showSessionsSelect: true
};

export default AdminGamesManager;
